"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringReader = void 0;
/** Reads a string char by char and keep track of the position. */
class StringReader {
    constructor(string) {
        this.position = 0;
        this.line = 1;
        this.character = 1;
        // Ignore \r in new line for files saved on Windows
        this.string = string.replace(/\r\n/g, '\n');
    }
    getChar() {
        if (this.reachedEnd()) {
            throw new Error('The end of the string has been reached');
        }
        return this.string.charAt(this.position);
    }
    getChars(count) {
        return this.string.slice(this.position, this.position + count);
    }
    getCharOrUndefined() {
        if (this.reachedEnd()) {
            return undefined;
        }
        return this.string.charAt(this.position);
    }
    reachedEnd() {
        return this.position === this.string.length;
    }
    skip(regexp) {
        while (!this.reachedEnd() && regexp.test(this.getChar())) {
            this.advance();
        }
    }
    match(text) {
        return this.string.startsWith(text, this.position);
    }
    advance(count = 1) {
        for (let i = 0; i < count; i++) {
            const char = this.getChar();
            this.position++;
            if (char === '\n') {
                this.line++;
                this.character = 1;
            }
            else {
                this.character++;
            }
        }
    }
    getStringPosition() {
        return {
            position: this.position,
            line: this.line,
            character: this.character,
        };
    }
}
exports.StringReader = StringReader;
//# sourceMappingURL=string_reader.js.map